import { InputLabel } from '@material-ui/core';
import useOKControlerField from 'components/OkStyleEditor/functionsUtils';
import React from 'react'

export default function Padding({ styleAtual, value, onChange }) {
    const okControler = useOKControlerField(value, onChange);
    return (       
        <div className='OkStyleEditor-comp'>
            <InputLabel>Padding</InputLabel>
            <div className='OkStyleEditor-row'>
                <div className='OkStyleEditor-cell50'>
                    <InputLabel>Top</InputLabel>
                    <input type='number' {...okControler('paddingTop')} />
                </div>
                <div className='OkStyleEditor-cell50'>
                    <InputLabel>Right</InputLabel>
                    <input type='number' {...okControler('paddingRight')} />
                </div>
            </div>
            <div className='OkStyleEditor-row'>
                <div className='OkStyleEditor-cell50'>
                    <InputLabel>Bottom</InputLabel>
                    <input type='number' {...okControler('paddingBottom')} />
                </div>
                <div className='OkStyleEditor-cell50'>
                    <InputLabel>Left</InputLabel>
                    <input type='number' {...okControler('paddingLeft')} />
                </div>

            </div>
        </div>
    )
}
